import { render } from "./감염내과.vue?vue&type=template&id=74c89326"
import script from "./감염내과.vue?vue&type=script&lang=js"
export * from "./감염내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__